<template>
    <span :key="id">
        <span v-if="shortFormat" :key="id">
            {{ prefix ? `${prefix} ` : "" }}
            {{ time | dateToHourFromSecondsShortFormat($i18n.locale, secondVisible) }}
            {{ suffix ? ` ${suffix}` : "" }}
        </span>
        <span v-else :key="id">
            {{ prefix ? `${prefix} ` : "" }}
            {{ time | dateToHourFromSeconds }}
            {{ suffix ? ` ${suffix}` : "" }}
        </span>
    </span>
</template>

<script>
import moment from "moment";
import { mapState } from "vuex";
import { log2 } from "../utils/log2";

const log = log2("PassedTimeCounterTimeFormat");
export default {
    name: "PassedTimeCounterTimeFormat",
    props: {
        date: {
            type: String,
            default: null,
        },
        endDate: {
            type: String,
            default: null,
        },
        shortFormat: {
            type: Boolean,
            default: false,
        },
        id: {
            type: String,
            default: null,
        },
        suffix: {
            type: String,
            default: null,
        },
        prefix: {
            type: String,
            default: null,
        },
        secondVisible: {
            type: Boolean,
            default: true,
        },
    },
    computed: mapState({
        timeDiff: (state) => state.auth.timeDiff + state.auth.latency,
    }),
    data() {
        return {
            time: 0,
            interval: null,
        };
    },
    methods: {
        start() {
            this.interval = setInterval(this.incrementTime, 1000);
        },
        incrementTime() {
            this.time = parseInt(this.time) + 1;
            /*log("incrementTime",{
                date:this.date,
                endDate:this.endDate,
                time:this.time,
                id:this.id
            })*/
        },
    },
    beforeDestroy() {
        clearInterval(this.interval);
    },
    mounted: function () {
        if (this.date) {
            const diff = this.endDate
                ? moment.duration(moment(this.endDate).add(this.timeDiff, "seconds").diff(moment(this.date)))
                : moment.duration(moment().add(this.timeDiff, "milliseconds").diff(moment(this.date)));
            this.time = diff.asSeconds();
        }
        if (!this.endDate) this.start();
    },
    created() {},
    updated() {
        /*log.debug("updated", {timeDiff: this.timeDiff})*/
    },
    watch: {
        id: function (newValue, oldValue) {
            this.id = newValue;
        },
    },
};
</script>

<style scoped></style>
